module.exports = __webpack_public_path__ + "static/img/store-icon7.8bdd366.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon7.png
// module id = OwIA
// module chunks = 1